<template>
    <div>
    <v-card raised class="mb-4">
    <v-layout row wrap>
    <v-flex xs12 md6>
        <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4 class="font-weight-bold">{{$t("Vehicle")}}:</v-flex>
        <v-flex d-flex xs8 class="font-weight-bold" >{{preReg.VehicleNo}} - {{preReg.VehicleLicensePlateNo}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
        <v-flex d-flex xs8>{{preReg.Facility}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
        <v-flex d-flex xs8 style="padding-right: 6px">{{preReg.ArticleNo}} - {{preReg.ArticleName}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
          <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
          <v-flex d-flex xs8 style="padding-right: 6px">{{preReg.CarrierNo}} - {{preReg.CarrierName}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
        <v-flex d-flex xs8 style="padding-right: 6px">{{getCustomerStr(preReg)}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Comment')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Comment")}}:</v-flex>
        <v-flex d-flex xs8>{{preReg.Comment1}}</v-flex>
        </v-layout>
    </v-flex>
    <v-flex xs12 md6>
        <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
        <v-flex d-flex xs8 style="padding-right: 6px">{{preReg.PlantNo}} - {{preReg.PlantName}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
        <v-flex d-flex xs8 style="padding-right: 6px">{{preReg.AgreementNo}} - {{preReg.AgreementName}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Delivery')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Delivery")}}:</v-flex>
        <v-flex d-flex xs8 style="padding-right: 6px">{{preReg.DeliveryNo}} - {{preReg.DeliveryName}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
          <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
          <v-flex d-flex xs8>{{preReg.RequisitionNo1}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('RequisitionNo2')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
          <v-flex d-flex xs4>{{$t("RequisitionNo2")}}:</v-flex>
          <v-flex d-flex xs8>{{preReg.RequisitionNo2}}</v-flex>
        </v-layout>
    </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-card-actions style="padding: 0px 0px 0px 0px" v-if="preReg.FinishedBy == null && !preReg.Completed">
    <v-flex xs6>
        <div style="padding: 0px 0px 0px 10px">{{$t("PreStatus" + preReg.PreStatus)}}</div>
        <div v-if="userVehicleLicensePlateNo && preReg.PreStatus == 1 && distance > 0" style="padding: 0px 0px 0px 10px">{{$t('Distance')}} {{distance}} km</div>
    </v-flex>
    <v-flex xs12 text-right>
        <v-btn v-if="userVehicleLicensePlateNo && preReg.PreStatus === 1" class="mr-1 mb-1" color="primary" @click="showScan">Scan</v-btn>
        <v-btn v-if="userVehicleLicensePlateNo && preReg.PreStatus === 3" class="mr-1 mb-1" color="primary" @click="showArrivalDialog = true">{{$t("Register arrival")}}</v-btn>
        <v-btn v-if="preReg.PreStatus === 1 || preReg.PreStatus === 3" class="mr-1 mb-1" :to="{name: 'edit-pre-registration-registration', params: {id: preReg.Id}}" color="primary">{{$t("Edit")}}</v-btn>
    </v-flex>
    </v-card-actions>
</v-card>

<v-dialog v-model="showArrivalDialog" max-width="600" @keydown.esc="showArrivalDialog = false" persistent>
    <v-card>
    <v-card-title v-if="arrivalTitleGPS" class="headline" primary-title>{{$t('GPS distance near location') + '  (' + distance + ' km)'}}</v-card-title>
    <v-card-title v-if="!arrivalTitleGPS" class="headline" primary-title>{{$t('QR-barcode scanned')}}</v-card-title>
    <v-container fluid grid-list-md >
        <v-layout row wrap>
        <v-flex xs12 md12>
            <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4 class="font-weight-bold">{{$t("Vehicle")}}:</v-flex>
            <v-flex d-flex xs8 class="font-weight-bold" >{{preReg.VehicleLicensePlateNo}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
            <v-flex d-flex xs8>{{preReg.Facility}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{preReg.CustomerName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{preReg.ArticleName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{preReg.PlantName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{preReg.AgreementName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Delivery')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Delivery")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{preReg.DeliveryName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Comment')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Comment")}}:</v-flex>
            <v-flex d-flex xs8>{{preReg.Comment1}}</v-flex>
            </v-layout>
        </v-flex>
        </v-layout>
    </v-container>
    <v-divider></v-divider>
    <v-card-actions>
        <v-container fluid grid-list-md  style="padding: 0px 0px 0px 14px">
        <v-layout row wrap>
            <v-flex xs12 md4>
            <v-flex d-flex xs12>{{$t("PreStatus3")}}</v-flex>
            </v-flex>
            <v-flex xs12 md3 align-self-center>
            <v-btn x color="error" @click="cancelArrivalAndReload">{{$t("Cancel")}}</v-btn>
            </v-flex>
            <v-flex xs12 md5 align-self-center>
            <v-btn color="success" @click="saveArrivalAndReload">{{$t("Register arrival")}}</v-btn> <!-- 4 = Arrival registered, awaiting loading -->
            </v-flex>
        </v-layout>
        </v-container>
    </v-card-actions>
    </v-card>
</v-dialog>

<v-dialog v-model="showScanDialog" max-width="600" @keydown.esc="showScanDialog = false" persistent>
    <audio id="prereg-sound"><source src="./../../../assets/snd/scannerbeep.mp3" type="audio/mp3"></audio>
    <v-card>
    <v-card-title class="headline bm=2" primary-title>
        {{$t("Scan QR-barcode")}}
    </v-card-title>
    <v-container fluid grid-list-md >
        <v-layout row wrap>
        <v-flex xs12 md12>
          <v-layout v-if="!isCameraLoaded && videoReady" row justify-center align-center>
            <v-icon size="200" color="warning">videocam</v-icon>
            {{this.$t('QR camera loading...')}}
          </v-layout>
          <StreamBarcodeReader v-if="videoReady" id="video" @decode="onQrDecode" @error="onQrError" @loaded="onQrLoaded"></StreamBarcodeReader>
          <v-layout v-if="!videoReady" row justify-center align-center>
            <v-icon size="200" color="error">warning</v-icon>
            {{this.$t('QR camera error')}}
          </v-layout>
        </v-flex>
        </v-layout>
    </v-container>
    <v-divider></v-divider>
    <v-card-actions>
        <v-container fluid grid-list-md  style="padding: 0px 0px 0px 14px">
        <v-layout row wrap>
            <v-flex xs12 md9>
            <v-flex d-flex xs12>{{$t("PreStatus1")}}</v-flex>
            </v-flex>
            <v-flex xs12 md3 align-self-center>
            <v-btn color="error" @click="showScanDialog = false; isCameraLoaded = false; videoReady = false">{{$t("Cancel")}}</v-btn>
            </v-flex>
        </v-layout>
        </v-container>
    </v-card-actions>
    </v-card>
</v-dialog>
</div>
</template>

<script>
import * as PreRegistration from '@/modules/pre-registration/pre-registration'
import * as Security from '@/core/security'
import { StreamBarcodeReader } from 'vue-barcode-reader'

export default {
  components: {
    StreamBarcodeReader
  },
  props: ['preReg'],
  data () {
    return {
      showScanDialog: false,
      showArrivalDialog: false,
      arrivalTitleGPS: false,
      distance: 0,
      userVehicleLicensePlateNo: null,
      videoReady: true,
      testVideoError: false,
      isCameraLoaded: false,
      isDecoding: false,
      hiddenFields: [],
      validQR: '/pre-registration-registrations/arrival'// ex. https://www.scanportal.net/pre-registration-registrations/arrival
    }
  },
  methods: {
    getCustomerStr (preReg) {
      if (preReg.CustomerNo && preReg.CustomerName) { return preReg.CustomerNo + ' - ' + preReg.CustomerName } else if (preReg.CustomerNo) { return preReg.CustomerNo } else if (preReg.CustomerName) { return preReg.CustomerName } else { return '' }
    },
    async save (val) {
      this.showArrivalDialog = false
      this.preReg.PreStatus = val
      const res = await PreRegistration.saveRegistration(this.preReg)
      if (!res.failed) {
        this.$root.$message.showSuccess(this.$t('PreStatus' + val))
        if (this.preReg.PreStatus === 4) location.reload() // Fix so camera gets turned off (using a lot of cpu)
      }
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    },
    cancelArrivalAndReload () {
      this.showArrivalDialog = false
      location.reload() // Fix so camera gets turned off (using a lot of cpu)
    },
    saveArrivalAndReload () {
      this.save(4) // 4 = Change to "Arrival registered, awaiting loading"
      // location.reload() // Fix so camera gets turned off (using a lot of cpu)
    },
    showScan () {
      this.isCameraLoaded = false
      if (!this.testVideoError) this.videoReady = true
      this.arrivalTitleGPS = false
      this.showScanDialog = true
    },
    onQrDecode (val) {
      // Play a beep also on iPad
      const myAudio = document.getElementById('prereg-sound')
      myAudio.play()

      if (this.showScanDialog && !this.isDecoding) {
        this.isDecoding = true
        console.log('Scan', '[' + val + ']')

        if (val && this.preReg.PreStatus === 1 && val.includes(this.validQR)) {
          this.preReg.PreStatus = 3 // Change to "Awaiting arrival registration"
          this.save(3) // 3 = Awaiting arrival registration
          this.showScanDialog = false
          this.showArrivalDialog = true
        }
        if (val && this.preReg.PreStatus === 1 && !val.includes(this.validQR)) {
          this.$root.$message.showError(this.$t('Barcode error') + '. (' + val + ')')
        }
        this.isDecoding = false
      } else console.log('Scan closed', '[' + val + ']')
    },
    onQrError (val) {
      this.$root.$message.showError(this.$t('QR camera error') + '. (' + val + ')')
    },
    onQrLoaded (val) {
      this.isCameraLoaded = true
    },
    async loadFacilityDetails () {
      const res = await PreRegistration.loadFacilityData({ facilityNo: this.preReg.Facility, corpName: Security.user.corporation })
      if (!res.failed && res.data !== null) {
        this.details = res.data.Details
        const preRegistrationGPSAcceptedDistanceKmDetail = this.details.find(o => o.Name === 'PreRegistration_GPSAcceptedDistanceKm')
        if (preRegistrationGPSAcceptedDistanceKmDetail !== undefined) {
          this.gpsAcceptedDistanceKm = preRegistrationGPSAcceptedDistanceKmDetail.Value
          console.log('Facility Target AcceptedDistanceKm: ', this.gpsAcceptedDistanceKm)
        }
        /* const preRegistrationGPSPositionDetail = this.details.find(o => o.Name === 'PreRegistration_GPSPosition')
        if (preRegistrationGPSPositionDetail !== undefined) {
          this.gpsTargetPosition = preRegistrationGPSPositionDetail.Value
        } */
      }
    },
    testVideo () {
      const video = document.getElementById('video')
      navigator.mediaDevices.getUserMedia({
        video: true
      }).then(
        stream => {
          this.$root.$message.showSuccess(video ?? this.$t('QR camera detected'))
          this.videoReady = true
        },
        err => {
          if (this.userVehicleLicensePlateNo) this.$root.$message.showError(this.$t('QR camera error') + '. (' + err + ')')
          this.videoReady = false
          this.testVideoError = true
        }
      )
    }
  },
  beforeDestroy () {
    // Unsubscribe to distance events
    this.$root.$off('distance', this.checkDistanceAndShowArrival)
  },
  async mounted () {
    // Load settings
    this.gpsAcceptedDistanceKm = Security.user.corporationDetails.find(d => d.Name === 'PreRegistration_GPSAcceptedDistanceKm')?.Data1 ?? '0.2'

    // load facility settings
    await this.loadFacilityDetails()

    // Open Arrival Dialog on accepted distance
    this.checkDistanceAndShowArrival = async (val) => {
      this.distance = val
      if (this.userVehicleLicensePlateNo && // only check GPS for users with a VehicleLicensePlateNo
            val <= this.gpsAcceptedDistanceKm && // GPS distance <= settings distance = Accepted Distance
            !this.showArrivalDialog && // dont reopen
            !this.showScanDialog && // not when scanning dialog open
            this.preReg.PreStatus === 1) { // only while waiting QR or GPS
        this.preReg.PreStatus = 3 // Change to "Awaiting arrival registration"
        this.save(3) // Awaiting arrival registration
        this.arrivalTitleGPS = true
        this.showArrivalDialog = true
      }
    }

    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      const defaultHidden = 'RequisitionNo2,Plant,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registration.vue
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'PreRegistration_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
    }
    // load Users VehicleLicensePlateNo - if any - and filter buttons and features off if no VehicleLicensePlateNo exist (ie. WheelLoader users).
    const userRes = await PreRegistration.userVehicleLicensePlateNo()
    if (!userRes.failed) {
      this.userVehicleLicensePlateNo = userRes.data.userVehicleLicensePlateNo
    }
    // Subscribe to distance change events and open Arrival Dialog on accepted distance
    this.$root.$on('distance', this.checkDistanceAndShowArrival)

    this.testVideo()
  }
}
</script>
